module.exports = __webpack_public_path__ + "img/banner.946adf1f.png";